// Centralized color configuration for analytics components

// Method badge color configuration 
export const METHOD_COLORS = {
  page: {
    background: '#4A90E2',  // Blue
    backgroundLight: 'bg-blue-100',
    text: 'text-blue-800',
    label: 'Page'
  },
  button: {
    background: '#50E3C2',  // Mint
    backgroundLight: 'bg-green-100',
    text: 'text-green-800',
    label: 'Button'
  },
  qrCode: {
    background: '#F5A623',  // Orange
    backgroundLight: 'bg-yellow-100',
    text: 'text-purple-800',
    label: 'QR code'
  }
};

// Other standard colors for sources
export const SOURCE_COLORS = [
  '#68C7CC', // Tipl teal
  '#F5A623', // Orange
  '#D0021B', // Red
  '#417505', // Green
  '#BD10E0', // Pink
  '#8B572A', // Brown
  '#7ED321', // Lime
  '#9B9B9B', // Gray
  '#4A4A4A', // Dark Gray
];

// Helper component for rendering method badges
export const MethodBadge = ({ method }) => {
  const colorConfig = METHOD_COLORS[method] || {
    backgroundLight: 'bg-gray-100',
    text: 'text-gray-800',
    label: method
  };
  
  return (
    <span 
      className={`inline-block px-2 py-1 text-xs rounded-full ${colorConfig.backgroundLight} ${colorConfig.text}`}
    >
      {colorConfig.label}
    </span>
  );
};
